module.exports = __webpack_public_path__ + "static/media/favicon2.c759b078.png";